<script setup lang="ts">
import AddMoreView from '../sections/AddMoreView.vue';

defineProps<{
  typedSearch: string;
  isTyping: boolean;
  showResults: boolean;
}>();
</script>

<template>
  <AddMoreView 
    :typedSearch="typedSearch" 
    :isTyping="isTyping" 
    :showResults="showResults" 
  />
</template>
